import { Injectable, signal } from '@angular/core';
import { ModalService } from '../utils/services/modal.service';
import { PaymentAccount } from '../schemas/payment_account';

@Injectable({
  providedIn: 'root',
})
export class BossServicesService {
  isNewPayment = signal<boolean>(false);
  isWifiQRCode = signal<boolean>(false);

  constructor() {}

  checkTransactions(paymentAccount?: PaymentAccount) {}
}
